/**
 * Customer-facing product subtitle authority (VO document second line).
 * Proposal interactive cards intentionally use Brand · Model via productDisplayName —
 * do not merge those policies without an explicit product decision.
 */

import {
  resolveCustomerFacingProductSubtitle,
  type CustomerFacingProductSubtitleInput,
} from "../customerFacingProductSubtitle";

export function renderProductSubtitle(
  input: CustomerFacingProductSubtitleInput,
): string | null {
  return resolveCustomerFacingProductSubtitle(input);
}
